import React, { Component } from 'react';

import './styles/modalCreditInfo.scss';

export default class ModalCreditInfo extends Component {
  render() {
    return (
      <div className="credit-info">
        <p>Подробную информацию об условиях кредита от <nobr>Т-банк</nobr> вы сможете увидеть после шага 3 при оформлении - на странице банка.</p>
      </div>
    )
  }
}